
function TriangleDownSVG() {
  return (
    <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0H10L5 5L0 0Z" fill="#2ABDBB"/>
    </svg>
  )
}

export { TriangleDownSVG }